import { subdivision } from "iso-3166-2";

const getRegionNameByCountryAndRegionCode = (
  countryCode: string,
  regionCode: string,
): string => {
  const region = subdivision(`${countryCode}-${regionCode}`);

  if (!region) {
    return regionCode;
  }

  const { name } = region;

  return name;
};

export default getRegionNameByCountryAndRegionCode;
